module.exports = __webpack_public_path__ + "static/beam-pattern-4ada0759577bcf58682c2e7d849c0c25.png";